import { Component, HostBinding, Input } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Helper } from '@rawlings/core';
import { PHONE_FORMAT } from '@app/member-response-portal/model/constants';

@Component({
    selector: 'app-input-phone',
    templateUrl: './input-phone.component.html',
    styleUrls: ['./input-phone.component.scss']
})
export class InputPhoneComponent {

    //#region Public Variables
    public PhoneFormat: string = PHONE_FORMAT;
    @Input() public Form! : FormGroup;
    @Input() public FormControlName! : FormControl;
    @Input() public ButtonDisabled! : boolean;
    @Input() public ShowButton! : boolean;
    @Input() public Label! : string;
    @Input() public InputId! : string;
    @Input() public InputName! : string;
    @HostBinding('class.input-phone') public SetClass:boolean = true;
    //#endregion Public Variables

    //#region Constructor
    //#endregion Constructor

    //#region Properties
    //#endregion Properties

    //#region Public Methods
    public SetErrorTooltipMessage(): string {
        const controlError: string[] = this.getErrorKeys(this.FormControlName.toString());

        if (!Helper.IsEmpty(controlError)) {
            if (controlError.includes('mask')) {
                return 'Invalid phone number'
            }

            return 'This field is required'
        }

        return ''
    }
    //#endregion Public Methods

    //#region Private Methods
    private getErrorKeys(controlName: string): string[] {
        const control:any = this.Form.get(controlName);
        if (control && control.errors) {
            return Object.keys(control.errors);
        }
        return null;
    }
    //#endregion Private Methods
}
